'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import type React from 'react';
import { useEffect, useState } from 'react';
import { Button, Container } from '@/components';
type Props = {
  title?: React.ReactNode | string;
  content: React.ReactNode | string;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
} & React.ComponentPropsWithoutRef<'div'>;
export function Confirm(t0) {
  const $ = _c(27);
  const {
    title,
    content,
    open,
    onConfirm,
    onCancel
  } = t0;
  const [isOpen, setIsOpen] = useState(open);
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      setIsOpen(open);
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onConfirm) {
    t3 = function handleConfirm() {
      setIsOpen(false);
      onConfirm();
    };
    $[3] = onConfirm;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleConfirm = t3;
  let t4;
  if ($[5] !== onCancel) {
    t4 = function handleCancel() {
      setIsOpen(false);
      onCancel();
    };
    $[5] = onCancel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleCancel = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogBackdrop className="dialog-backdrop" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== title) {
    t6 = <DialogTitle className="dialog-title">{title}</DialogTitle>;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== content) {
    t7 = <section className="text-zinc-700 dark:text-zinc-300">{content}</section>;
    $[10] = content;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleCancel) {
    t8 = <Button type="button" variant="outline" onClick={handleCancel} className="h-10 w-28" aria-label="Cancel">Cancel</Button>;
    $[12] = handleCancel;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleConfirm) {
    t9 = <Button type="button" variant="secondary" onClick={handleConfirm} className="h-10 w-28" aria-label="Confirm">Yes</Button>;
    $[14] = handleConfirm;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <div className="mt-8 flex justify-end gap-x-3">{t8}{t9}</div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t6 || $[21] !== t7) {
    t11 = <Container size="xs" className="fixed inset-0 z-20 flex items-center justify-center"><DialogPanel transition={true} className="dialog-panel">{t6}{t7}{t10}</DialogPanel></Container>;
    $[19] = t10;
    $[20] = t6;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== handleCancel || $[24] !== isOpen || $[25] !== t11) {
    t12 = <Dialog open={isOpen} onClose={handleCancel} className="relative z-40 overflow-y-scroll">{t5}{t11}</Dialog>;
    $[23] = handleCancel;
    $[24] = isOpen;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}